export enum cpcCpm {
    cpc = "cpc",
    cpm = "cpm"
}